import React from 'react';
import { Icon } from './Icon.js';
export const IconBlueprintFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M12 9.25C12 10.2165 11.2165 11 10.25 11H5V6H12V9.25Z", fill: "currentColor" }),
        React.createElement("path", { d: "M3.5 11H1.75C0.783502 11 0 10.2165 0 9.25V2.75C0 1.7835 0.783502 1 1.75 1H3.5V11Z", fill: "currentColor" }),
        React.createElement("path", { d: "M9.25 1C10.2165 1 11 1.7835 11 2.75V4.5H5V1H9.25Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconBlueprintFill12.js.map